import { Routes } from '@angular/router';
import {
  AuthGuard,
  GENERAL_CONSTANTS,
  HowdenMainLayoutComponent,
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  NotAuthorizedComponent
} from '@howdeniberia/core-front';
import { APP_ROLES } from './core/constants';
import { HomeRoutes } from './features/home/home-routing';
import { SaneProjectRoutes } from './features/sane-projects/sane-project-routing';
import { FileLibraryRoutes } from './features/file-library/file-library-routing';

const ENABLE_FILE_LIBRARY = false as const; // <- switch to true to bring "Biblioteca" back

export const AppRoutes = [
  {
    path: '',
    component: HowdenMainLayoutComponent, 
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      isLayout: true,
      roles: [...APP_ROLES.ALL]
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/home' },
      ...HomeRoutes,
      ...SaneProjectRoutes,
      ...(ENABLE_FILE_LIBRARY ? FileLibraryRoutes : [])
    ]
  },
  {
    path: GENERAL_CONSTANTS.NotAuthorizedUrl,
    title: $localize`:@@app.route.notauthorized: No autorizado`,
    component: NotAuthorizedComponent
  },
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  { path: '**', redirectTo: '404' }
] as Routes;